module.exports = __webpack_public_path__ + "static/media/ic_account_circle_black.bb3cb656.svg";